import {useState} from "react"
import {Modal} from "../question/Modal"
import {color_note} from "../Fonctions"


export function Essais_eleve ({auth, user, updateUser}) {
  //console.log(user)
  const [show_activite, setShow_activite] = useState(false)
  //const [tab, setTab] = useState([])
  const [msg, setMsg] = useState('')
  const [data_serie, setData_serie] = useState({
    selection:'',
    niveau:'',
    etoile:'',
    nb_question:'',
  })

  const cleanMsg = () => {
    setTimeout(e => setMsg(''), 5000)
  }

  const handleClick = (e) => {
    const activ = user.mes_essais.find(elt=> elt.activite === e.target.title)
    setShow_activite(true)

    setData_serie({
      activite:e.target.title,
      selection:e.target.title.split('__'),
      nb_question:activ.nb_question,
      etoile:activ.etoile,
      niveau:activ.niveau
    })
    }

  const handleSubmit = (e) => {
    let confirm = window.confirm("Voulez-vous vraiment supprimer ce devoir ?");
    if (!confirm) {return}
    
    fetch("https://maths-au-quotidien.fr/react-automaths/api-database.php", {
      method: 'POST',
      body: JSON.stringify({...auth, action:'eleve_suppr_devoir', id:user.id, id_activite:e.target.id})
    })
    .then(response => response.json())
    .then(data => {
      setMsg(data)
      updateUser('eleve_suppr_devoir')
      cleanMsg()
    })
    .catch(err => console.log(err))
  }

  //console.log(user.mes_essais)
  return (
    <>
    {msg && <span dangerouslySetInnerHTML={{ __html:msg}}></span>}
    {show_activite ?
      <Modal auth={{...auth, notion:data_serie.activite.split('__'), activite:data_serie.activite, niveau:data_serie.niveau, etoile:data_serie.etoile, nb_question:data_serie.nb_question, action:'rech_question'}} setShow_activite={setShow_activite} />
      /*<div className='modal active'> 
      <div className="suppr_serie" onClick={()=>{setShow_activite(false)}}></div>
        <AAA002 auth={{...user, ...auth}} updateUser={updateUser} data_serie={data_serie} tab={tab} setTab={setTab} setShow_activite={setShow_activite} color_note={color_note} /> 
      </div>*/ 
      :  
    <div className="content max">
      <h1>Mes essais</h1>
    	{user.mes_essais.length ? 
          <div className="flex">
          {user.mes_essais.map((activ, k) => 
            <div key={k} className="etiquette" title={activ.activite.replaceAll('__', '\u000d')}>
            <div className="suppr_serie" id={activ.id}  onClick={handleSubmit}></div>
            <div className="info_mess">{activ.dates.slice(0,5)}&nbsp;&nbsp;&nbsp;</div>
            <span className={color_note(activ.note)}><b>{activ.note}%</b></span> {'⭐'.repeat(activ.etoile)} <div className="nb_question_serie">{activ.nb_question}Q</div><br/>
              {activ.title || activ.activite.split('__').map((e, key)=><div key={key}>{e.split('/')[1] || e}</div>)}
              <div name='replay' title={activ.activite} className="replay" onClick={handleClick} ></div>
            </div>
          )}</div> 
          : <>
            Retrouvez, ici, les activités faites en autonomie.<br/>
            (sans qu'elles soient données en devoir par votre professeur)<br/><br/>
            <div className="alert info ">
              <br/>Vous n'avez pas encore effectué d'essai.<br/><br/>
            </div>
            </>
        }
    </div>
    }
    </>
  );
}